module.exports = __webpack_public_path__ + "media/images/redesign-images/ma/profile-images/gracie-jackson-57221ac70cc542b5ea0dff56a83e6e83.jpg";